import { ClientProjectData } from '@modules/EvaluationModule/interfaces/ClientProjectData';
import { ClientContactData } from '@modules/EvaluationModule/interfaces/ClientSubProjectData';
import { ClientSubProjectFilterOptions } from '@modules/EvaluationModule/interfaces/ClientSubProjectFilterOptions';
import { ClientWorkstreamData } from '@modules/EvaluationModule/interfaces/ClientWorkstreamData';
import {
  AddClietContactData,
  ModifyClientContactData,
} from '@modules/EvaluationModule/interfaces/ClietContactFormData';
import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from '@shared/interfaces/asyncData';
import { DataState } from '@shared/enums/DataState';

export const getClientContactData = createAction('clientContactPage/getClientContactData');
export const setClientContactData = createAction<AsyncData<ClientProjectData[]>>(
  'clientContactPage/setClientContactData'
);

export const getClientWorkstreamsData = createAction<{ clientId: string }>(
  'clientContactPage/getClientWorkstreamsData'
);
export const setClientWorkstreamsLoading = createAction<{ clientId: string }>(
  'clientContactPage/setClientWorkstreamsLoading'
);
export const setClientWorkstreamsData = createAction<{
  clientId: string;
  data: ClientWorkstreamData[] | null;
  state: DataState;
}>('clientContactPage/setClientWorkstreamsData');

export const addClientContact = createAction<AddClietContactData>('clientContactPage/addClientContact');
export const editClientContact = createAction<ModifyClientContactData>('clientContactPage/editClientContact');

export const setClientSubProjectNetworkError = createAction<string | null>(
  'clientContactPage/setClientSubProjectNetworkError'
);

export const setClientSubProjectFilters = createAction<Partial<ClientSubProjectFilterOptions>>(
  'clientContactPage/setClientSubProjectFilters'
);

export const getClientWorkstreamContactsData = createAction<{
  workstreamId: string | null;
  clientId: string | null;
}>('clientContactPage/getClientWorkstreamContactsData');
export const setClientWorkstreamContactsData = createAction<{
  clientId: string | null;
  workstreamId: string | null;
  data: ClientContactData[] | null;
  state: DataState;
}>('clientContactPage/setClientWorkstreamContactsData');
